import settings from '@/settings'

const gerenciar = (headers, payload) => {
  let url = `${settings.apetrusApi}/assinatura/gerenciar-no-posto/`

  if (payload.parametros) {
    const keys = Object.keys(payload.parametros)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload.parametros[keys[i]]}`
    }
  }

  const data = {
    method: payload.method,
    mode: 'cors',
    headers: headers
  }

  if (payload.method === 'GET') {
    data.cache = 'default'
  } else {
    data.body = JSON.stringify(payload.body)
  }

  return fetch(url, data)
}

const pegarPlanos = (headers, payload) => {
  let url = `${settings.apetrusApi}/assinatura/planos/`

  if (payload) {
    const keys = Object.keys(payload)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload[keys[i]]}`
    }
  }

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const cancelarEfi = (data, headers) => {
  return fetch(`${settings.apetrusApi}/assinatura/cancelar-assinatura/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const planoComItens = (headers, payload) => {
  let url = `${settings.apetrusApi}/assinatura/plano-com-itens/${payload.id ? `${payload.id}/` : ''}`
  const data = {
    method: payload.method,
    mode: 'cors',
    headers: headers
  }
  if (payload.method === 'GET') {
    data.cache = 'default'
  } else {
    data.body = JSON.stringify(payload.body)
  }

  if (payload.parametros) {
    const keys = Object.keys(payload.parametros)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload.parametros[keys[i]]}`
    }
  }

  return fetch(url, data)
}

const aplicarDescontoFidelize = (headers, data, cnpj) => {
  return fetch(`${settings.apetrusApi}/assinatura/aplicar-desconto-fidelize/?empresa=${cnpj}`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const sugestaoFidelize = (headers, data, cnpj) => {
  return fetch(`${settings.apetrusApi}/assinatura/sugestao-fidelize/?empresa=${cnpj}`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

export default {
  gerenciar,
  pegarPlanos,
  cancelarEfi,
  planoComItens,
  aplicarDescontoFidelize,
  sugestaoFidelize
}
